<template>
  <v-lazy style="min-width: 0" :options="{ threshold: 0.5 }">
    <AGFlexContainer class="ag-no-data-text" direction="row" align="center" gap="12px">
      <AGIcon v-if="icon" size="16px" :icon="icon" :color="iconColor" />
      <AGTruncatedText :text="text" :tooltip-activator-class="tooltipActivatorClass" />
    </AGFlexContainer>
  </v-lazy>
</template>

<script>
import AGFlexContainer from '@/components/common/AGFlexContainer.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import AGTruncatedText from '@/components/common/AGTruncatedText.vue';

export default {
  components: {
    AGFlexContainer,
    AGIcon,
    AGTruncatedText,
  },

  props: {
    text: {
      type: [String, Number],
      default: '-',
    },

    icon: {
      type: String,
      required: false,
    },

    iconColor: {
      type: String,
      required: false,
    },

    hasTooltip: {
      type: Boolean,
      default: false,
    },

    tooltipActivatorClass: {
      type: String,
      default: 'ag-no-data-text__tooltip_activator',
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-no-data-text {
  ::v-deep(.ag-no-data-text__tooltip_activator) {
    min-width: 0;
    flex: 1;
  }
}
</style>
